'use strict';
var PromoBannerSideColController = /** @class */ (function () {
    /*@ngInject*/
    function PromoBannerSideColController(Auth, $scope, $log, PromoBannerSideColService) {
        this.Auth = Auth;
        var self = this;
        this.Auth.isLoggedIn(function (loggedInUser) {
            if (loggedInUser) {
                // $log.info('In promo banner..current user is..', loggedInUser);
                self.loggedInUser = loggedInUser;
                if (self.loggedInUser.accountType == 'Practitioner') {
                    self.id = 9022;
                    // console.log("as practitioner", self.id);
                }
                else if (self.loggedInUser.accountType == 'Patient') {
                    self.id = 9022;
                    // console.log("as patient", self.id);
                }
            }
            else {
                self.id = 9022;
                // console.log("as non logged in", self.id);
            }
            PromoBannerSideColService.getContent(self.id)
                .then(function (response) {
                self.coopBannerSide = response.data;
            });
        });
    }
    return PromoBannerSideColController;
}());
export default PromoBannerSideColController;
//# sourceMappingURL=promo-banner-side-col.controller.js.map